import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import colors from '../Constant/colors';

const StudentLedgers = () => {
  const [students, setStudents] = useState([]);
  const [allStudents, setAllStudents] = useState([]);
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  // Global styles
  const title18 = { fontSize: "18px", fontWeight: "700", color: "#000" };
  const label18 = { fontSize: "18px", fontWeight: "600", color: "#000" };
  const input14 = {
    fontSize: "14px",
    border: "1px solid #1E40AF",
    padding: "10px",
    borderRadius: "8px",
    width: "100%",
    background: "#fff",
  };
  const button18 = {
    fontSize: "18px",
    padding: "10px 20px",
    borderRadius: "8px",
    fontWeight: "600",
    color: "#fff",
    background: colors.gradientPrimary,
    border: "none",
    cursor: "pointer",
  };

  // Fetch classes initially
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses`)
      .then(res => res.json())
      .then(data => setClasses(data))
      .catch(err => console.error(err));
  }, []);

  // Fetch sections when selectedClass changes
  useEffect(() => {
    if (selectedClass) {
fetch(`${process.env.REACT_APP_API_BASE_URL}/api/sections/${selectedClass}/getSectionsByClassName?sessionId=${localStorage.getItem("currentSessionId")}`)
  .then(res => res.json())
  .then(data => {
    // Ensure sections is always an array
    setSections(Array.isArray(data) ? data : []);
  })
  .catch(err => {
    console.error(err);
    setSections([]); // fallback to empty array if API fails
  });

    } else {
      setSections([]);
    }
  }, [selectedClass]);

  // Fetch all students initially
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents?sessionId=${localStorage.getItem("currentSessionId")}`)
      .then(res => res.json())
      .then(data => {
        setStudents(data);
        setAllStudents(data);
      })
      .catch(err => console.error(err));
  }, []);

  // Filter students based on class/section
  useEffect(() => {
    let filtered = allStudents;
    if (selectedClass) filtered = filtered.filter(s => s.class === selectedClass);
    if (selectedSection) filtered = filtered.filter(s => s.section === selectedSection);
    setStudents(filtered);
  }, [selectedClass, selectedSection, allStudents]);

  const handleSearch = () => {
    const filtered = allStudents.filter(student =>
      (student.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        student.lastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (student.fatherName && student.fatherName.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (student.rollNo && student.rollNo.toString().toLowerCase().includes(searchQuery.toLowerCase()))
      )
    );
    setStudents(filtered);
  };

  const handleKeyDown = (e) => { if (e.key === 'Enter') handleSearch(); };

  return (
    <div className="min-h-screen bg-white flex justify-center py-12">
      <div className="w-full max-w-7xl px-4">

        <p style={{ fontSize: "14px", color: "#666", marginBottom: "8px" }}>
          View and manage student ledgers.
        </p>

        {/* Filter/Search Card */}
        <div className="bg-gray-100 rounded-lg shadow-sm p-4 mb-6">
          {/* Search Row */}
          <div className="flex flex-col md:flex-row gap-3">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Search by name, father's name, or roll number"
              style={input14}
            />

            <button onClick={handleSearch} style={button18}>
              Search
            </button>
          </div>

          {/* Filters */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
            <select
              value={selectedClass}
              onChange={(e) => setSelectedClass(e.target.value)}
              style={input14}
            >
              <option value="">Select Class</option>
              {classes.map(cls => (
                <option key={cls.id} value={cls.className}>{cls.className}</option>
              ))}
            </select>

            <select
              value={selectedSection}
              onChange={(e) => setSelectedSection(e.target.value)}
              style={input14}
            >
              <option value="">Select Section</option>
              {sections.map(sec => (
                <option key={sec.id} value={sec.sectionName}>{sec.sectionName}</option>
              ))}
            </select>
          </div>
        </div>

        {/* Students Table */}
        <div className="bg-gray-100 rounded-lg shadow-sm p-4">
          <h2 style={title18} className="flex items-center gap-2 mb-3">
            <i className="fas fa-users text-green-600"></i> Students
          </h2>

          {students.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border border-gray-300 rounded-md text-center">
                <thead className="bg-gray-200">
                  <tr>
                    {["Student Name", "Father's Name", "Roll Number", "Actions"].map((h, i) => (
                      <th
                        key={i}
                        style={{ fontSize: "18px", fontWeight: "600", color: "#000" }}
                        className="px-3 py-2 border"
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {students.map(student => (
                    <tr key={student._id} className="hover:bg-gray-50">
                      <td className="px-3 py-2 border text-left" style={{ fontSize: "14px" }}>
                        {student.firstName} {student.lastName}
                      </td>
                      <td className="px-3 py-2 border text-left" style={{ fontSize: "14px" }}>
                        {student.fatherName}
                      </td>
                      <td className="px-3 py-2 border" style={{ fontSize: "14px" }}>
                        {student.rollNo}
                      </td>

                      <td className="px-3 py-2 border">
                        <Link to={`/ledger/${student._id}`}>
                          <button
                            style={{
                              ...button18,
                              background: "#16A34A",
                              padding: "6px 16px",
                              fontSize: "18px",
                            }}
                          >
                            View Ledger
                          </button>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>

              </table>
            </div>
          ) : (
            <p style={{ fontSize: "14px", color: "#555" }}>No students found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudentLedgers;
